export const fetchFromApiMocked = (commit, data) => {
  commit('setData', data)
  commit('setLoadedState', true)
  commit('setLoadingState', false)
}
